var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSynchPayLeftSideLogo = function SvgSynchPayLeftSideLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#100E12",
    d: "M25.042 24.991h21.006V0H25.042C11.213 0 0 11.19 0 24.991c0 4.551 1.233 8.84 3.364 12.496 4.336-7.46 12.409-12.496 21.678-12.496M25.042 50.022c-9.269 0-17.342-5.036-21.678-12.496C1.233 41.219 0 45.471 0 50.022c0 13.801 11.213 24.991 25.042 24.991h21.006V50.022Z"
  })));
};
export default SvgSynchPayLeftSideLogo;